var generateStyle = function generateStyle(componentTheme) {
  return {
    detailsWrapper: {
      marginLeft: '3.5rem',
      paddingTop: componentTheme.detailsWrapperTopPadding
    },
    listItem: {
      borderTop: "".concat(componentTheme.listItemBorderWidth, " solid ").concat(componentTheme.listItemBorderColor),
      margin: '0',
      padding: "".concat(componentTheme.listItemPadding, " 0")
    }
  };
};
export default generateStyle;